const testimonials = {
  testimonials: [
    {
      text:
        "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work. And the only way to do great work is to love what you do. If you haven't found it yet, keep looking. Don't settle. As with all matters of the heart, you'll know when you find it.",
      said_by: "Steve Jobs",
    },
    {
      text:
        "We can't solve problems by using the same kind of thinking we used when we created them.",
      said_by: "Albert Einstein",
    },
    {
      text: "The true ENTREPRENEUR is a risk taker, not an excuse maker.",
      said_by: "VDEXTERS",
    },
    {
      text: "Website without visitors is like a ship lost in the horizon.",
      said_by: "Dr. Christopher Dayagdag",
    },
    {
      text:
        "Learning HTML and CSS is a lot more challenging than it used to be. Responsive web design adds more layers of complexity to design and develop websites.",
      said_by: "Jacob Lett",
    },
    {
      text:
        "JavaScript’s global scope is like a public toilet. You can’t avoid going in there, but try to limit your contact with surfaces when you do.",
      said_by: "Dmitry Baranovskiy",
    },
    {
      text:
        "Reusability is key in reducing bugs and coding quickly. The more I use a piece of code, the more confident and familiar I become with it, which in turn significantly speeds up my development time.",
      said_by: "Robert Duchnik",
    },
  ],
};
export default testimonials;
